module.exports = __webpack_public_path__ + "img/140.10.15dc7c1f.png";